/** @jsx jsx */

import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import { jsx, css } from "@emotion/react";

const onePadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const topBottomPadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const titlePadding = css`
padding-bottom:1em;
`;

type UploaderVideoPreviewProps = {
    videoSrc: string | undefined,
    videoType: string | undefined,
    title: string
}

const UploaderVideoPreview: React.FC<UploaderVideoPreviewProps> = ({ videoSrc, videoType, title }) => {
    const playerRef = useRef<null | HTMLVideoElement>(null);
    const vSrc = videoSrc;
    const vType = videoType;

    useEffect(() => {
        console.log("[DEBUG][UploaderVideoPreview] useEffect");
        const playerOption = {
            autoplay: true,
            controls: true,
            muted: true
        };

        const player = videojs(playerRef.current, playerOption, () => {
            player.src([
                {
                    type: vType,
                    src: vSrc,
                },
            ]);
        });
    });

    return (
        <div css={topBottomPadding} >
            <h3 css={titlePadding}>{title}</h3>
            <div css={onePadding}>
                <video
                    width="560"
                    height="315"
                    id="player"
                    ref={playerRef}
                    className="video-js vjs-default-skin vjs-big-play-centered"
                    preload="auto"
                    playsInline
                    controls
                >
                </video>
            </div>
        </div>
    );
};

export default UploaderVideoPreview;

